import { allPageTypes } from "global/enums/allPageTypes"
import { useContext } from "react"
import { ParentContext } from "../ParentContext"
import { settingsIconTypes } from "global/enums/settingsIconTypes"

export const useAllowAdmin = ({ gcProps }) => {

  const pageIcons = null

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state, paps_state, appUser_state } = states
  const { appUser } = appUser_state ?? {}
  const { appUserAccess } = appUser ?? {}
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  // pageContext 
  const { pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appNotifications, appUserPermissions } = aps_global ?? {}
  const { allowRequestAccess } = appUserPermissions ?? {}

  const { allowNotificationTopics, showTopicsManagerOnHomeScreen } = appNotifications ?? {}

  const allowedItem = (viewItem, segProps, gcProps, hidden) => {
    const { key } = viewItem ?? {}
    return { viewItem, itemKey: key, segProps, gcProps, hidden }
  }

  let showProfiles;

  if (pathViews.clients) {
    showProfiles = isSuperAdminDeveloper
  } else {
    showProfiles = true
  }

  const items = []
  if (!pageIcons) {
    items.push(allowedItem({ key: allPageTypes.appDashboard }, { caption: 'App Dashboard', icon: settingsIconTypes.dashboard, cn: 'ao' }, gcProps))
    showProfiles && items.push(allowedItem({ key: allPageTypes.appProfilesManager }, { caption: 'App Profiles', icon: settingsIconTypes.appProfiles, cn: 'ao' }, gcProps))
    pathViews.clients && items.push(allowedItem({ key: allPageTypes.appUsersManager }, { caption: 'App Users', icon: settingsIconTypes.appUsers, cn: 'ao' }, gcProps))
    allowRequestAccess && items.push(allowedItem({ key: allPageTypes.appUserRequests }, { caption: 'App Requests', icon: settingsIconTypes.appAccessRequests, cn: 'ao' }, gcProps))
    allowNotificationTopics && showTopicsManagerOnHomeScreen && items.push(allowedItem({ key: allPageTypes.topicsManager }, { caption: 'Topics', icon: 'chat', cn: 'ao' }, gcProps))
  }
  return items

}